import React, { useContext } from 'react';
import { BarChart } from '../../../BarChart';
import classes from '../../../ChartPanel/ChartPanel.module.scss';
import { Loader } from '../../../../../components/containers/Loader';
import { Panel } from '../../../../../components/containers/Panel';
import { PanelHeader } from '../../../../../components/containers/Panel/PanelHeader.view';
import { Button } from '../../../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../../../constants/button-colors';
import { ButtonGroup } from '../../../../../components/containers/ButtonGroup';
import { EngagementTab, metricToTab } from './EngagementOnPostChart.controller';
import { BarChartData } from '../../../BarChart/BarChart.controller';
import { EmptyScreen } from '../../../LineChart/EmptyScreen';
import { AnalyticsContext } from '../../../AnalyticsProvider';
import { Metrics } from '../../helpers/chartHelpers';

type EngagementOnPostChartViewProps = {
  loading: boolean;
  activeTab: EngagementTab;
  setActiveTab: (tab: EngagementTab) => void;
  chartData: BarChartData[];
  datesChart: Date[];
  firstDateFromData: string;
  lastDateFromData: string;
  maxValueAxisY: number;
  isEmpty: boolean;
  activeMetrics: Metrics[];
  availableMetrics: Metrics[];
};
export const EngagementOnPostChartView = ({
  loading,
  activeTab,
  setActiveTab,
  activeMetrics,
  availableMetrics,
  chartData,
  datesChart,
  firstDateFromData,
  lastDateFromData,
  maxValueAxisY,
  isEmpty
}: EngagementOnPostChartViewProps) => {
  const { selectedProfilesIds } = useContext(AnalyticsContext);

  return (
    <div className={'cell'}>
      <Panel customClass={classes.ChartContainer}>
        <PanelHeader
          title={'Engagement on Posts'}
          subTitle={'Total likes, comments and shares'}
          subTitleTooltip={'Total engagement for all Posts published on each day.'}
          isChartPanel
        />

        {!isEmpty && (
          <ButtonGroup size={'large'}>
            <Button
              type={'button'}
              size={'medium'}
              color={ButtonColorsEnum.primary}
              action={() => setActiveTab(EngagementTab.engagement)}
              variant={activeTab === EngagementTab.engagement ? 'solid' : 'hollow'}>
              Total Engagements
            </Button>
            {availableMetrics.map(metric => {
              return (
                <Button
                  key={metric}
                  type={'button'}
                  size={'medium'}
                  color={ButtonColorsEnum.primary}
                  action={() => setActiveTab(metricToTab[metric])}
                  variant={activeTab === metricToTab[metric] ? 'solid' : 'hollow'}>
                  {metric}
                </Button>
              );
            })}
          </ButtonGroup>
        )}
        {loading && (
          <div className={classes.LoaderContainer}>
            <Loader variation={'dark'} size={'large'} />
          </div>
        )}
        {isEmpty && !loading && <EmptyScreen noProfiles={selectedProfilesIds.length === 0} />}
        {!loading && !isEmpty && (
          <BarChart
            loading={loading}
            activeMetrics={activeMetrics}
            chartData={chartData}
            datesChart={datesChart}
            firstDateFromData={firstDateFromData}
            lastDateFromData={lastDateFromData}
            maxValueAxisY={maxValueAxisY}></BarChart>
        )}
      </Panel>
    </div>
  );
};
